import React from 'react'
import * as styles from 'src/components/page/layout/footer/links-list.module.scss'

interface Props {
  title: string
  links: { [title: string]: string }
}

export const LinksList: React.FC<Props> = ({ title, links }) => (
  <>
    <h3 className="stk-text-h4">{title}</h3>

    <ul className={styles.linksList__list}>
      {Object.keys(links).map((title) => (
        <li key={title}>
          <a href={links[title]}>{title}</a>
        </li>
      ))}
    </ul>
  </>
)
